import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ViewEncapsulation, Input, ChangeDetectorRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { StoryChapterThumbnail } from 'src/app/story/models/story-chapter-thumbnail.model';
import { ViewService } from '../../view.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-view-chapters',
  templateUrl: './view-chapters.component.html',
  styleUrls: ['./view-chapters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None

})
export class ViewChaptersComponent implements OnInit, OnDestroy {
  // ---------- Observables ----------
  @Select(StoryChaptersState.getStoryChapters)
  chapters$: Observable<ChapterModel>;

  @Select(StoryChaptersState.getSelectedChapterId)
  selectedChapterId$: Observable<string>;

  @Select(StoryChaptersState.getSelectedChapterIndex)
  selectedChapterIndex$: Observable<number>;

  @Select(StoryChaptersState.getRegisteredThumbnails)
  thumbnails$: Map<string, StoryChapterThumbnail>;



  // ---------- Inputs ----------
  @Input()
  showHeader = true;
  
  @Input()
  showList = true;

  @Input()
  defaultImage = '/assets/images/view-chapter-thumbnail-placeholder.png';

  // ---------- Class Variables ----------
  ngUnsubscribe = new Subject();
  nextChapter: ChapterModel = null;



  // ---------- Lifecycle ----------
  constructor(
    private store: Store,
    private viewService: ViewService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.initChaptersObserver();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }



  // ---------- Observers ----------
  initChaptersObserver() {
    combineLatest([
      this.store.select(StoryChaptersState.getStoryChapters),
      this.store.select(StoryChaptersState.getSelectedChapterIndex)
    ]).pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(([chapters, index]) => {
      const nextIndex = index + 1;
      this.nextChapter = (nextIndex >= chapters.length) ? null : chapters[nextIndex];
      this.changeDetectorRef.markForCheck();
    });
  }




  // ---------- Interaction ----------
  handleChapterClick(chapter: ChapterModel) {
    this.viewService.selectChapter(chapter);
  }

  handleNextChapterClick() {
    this.viewService.nextChapter();
  }

  handleToggleList() {
    this.showList = !this.showList;
  }



  // ---------- Utility ----------
  getChapterThumb(chapterId: string): string {
    const thumbnails = this.store.selectSnapshot(StoryChaptersState.getRegisteredThumbnails);
    const thumbnail = thumbnails.get(chapterId);

    // use snapshot if present, otherwise use small
    if (!!thumbnail) {
      return thumbnail.snapshot || thumbnail.urls.small;
    } else {
      return '';
    }
  }

}
